import { loader, showMessage } from "../../components/message"
import { usuario } from "../../usuario"
import { getUrlAction, loginMessage, newPage, inputIsValid, convertAmericanDateToBR } from "../../utils"
import templateMeusDados from './MeusDados.hbs'

export const MeusDados = () => {
    if (usuario.logado) {

        newPage({
            appbarTitle: 'Meus dados'
        })

        select('.page-body').innerHTML = templateMeusDados({
            usuario,
            masculino: usuario.sexo === 0,
            feminino: usuario.sexo === 1,
            email: usuario.email,
            dataNascimento: convertAmericanDateToBR(usuario.dataNascimento)
        });

        const telefone = select('#meus-dados #telefone')
        const senha = select('#meus-dados #senha')
        const confirmarSenha = select('#meus-dados #confirmar-senha')
        const button = select('#meus-dados #save-data')
        const aniversario = select('#aniversario')
        const email = select('#email')

        $(telefone).mask('(00) 0000-00009')
        $(aniversario).mask('00/00/0000')

        $('.dados-log-out a').on('click', () => {
            const callback = () => {
                $('.message-box button:first-of-type').on('click', () => {
                    window.location = getUrlAction('Account', 'logout')
                })
                $('.message-box button:last-of-type').on('click', () => {
                    select('.message-box').remove()
                })
            }

            showMessage(
                '',
                'Tem certeza que deseja sair?',
                'warning',
                '',
                callback,
                true,
                'small',
                true
            )
        })

        button.classList.remove('btn-disabled')

        button.addEventListener('click', function () {
            if (inputIsValid(telefone)) {

                telefone.style.borderColor = ''
                senha.style.borderColor = ''
                confirmarSenha.style.borderColor = ''

                const sexoLabelChecked = select('[name="sex"]:checked')
                const sexo = sexoLabelChecked ? sexoLabelChecked.value : ''
                if (senha.value == confirmarSenha.value) {
                    const cUrl = getUrlAction('Cadastros', 'SetDadosUsuario')

                    const emailValue = email ? email.value : ''
                    button.innerHTML = loader()
                    setTimeout(() => {
                        $.ajax({
                            url: cUrl,
                            type: 'POST',
                            data: {
                                telefone: telefone.value,
                                senha: senha.value,
                                confirmarSenha: confirmarSenha.value,
                                sexo: sexo,
                                email: emailValue,
                                dataNascimento: aniversario.value
                            },
                            async: true,
                            success: (response) => {
                                response = JSON.parse(response)
                                button.innerHTML = 'Alterar'
                                showMessage(
                                    '',
                                    response.msg || (response.lValid ? 'Dados alterados com sucesso!' : 'Erro ao alterar dados!'),
                                    response.lValid ? 'success' : 'error',
                                    'OK',
                                    () => {
                                        let buttonOK = select('.message-box button')
                                        buttonOK &&
                                            $(buttonOK).on('click', function () {
                                                select('.message-box').remove()
                                            })
                                    }
                                )
                            },
                            error: () => { }
                        })
                    }, 100)
                } else {
                    senha.style.borderColor = '#ff304f'
                    confirmarSenha.style.borderColor = '#ff304f'
                    alert('As senhas não correspondem')
                }
            }
        })


    } else {
        loginMessage()
    }
}